import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { PhotoCarousel } from './components/PhotoCarousel';
import { Intro } from './components/Intro';
import { Experience } from './components/Experience';
import { House } from './components/House';
import { Breakfast } from './components/Breakfast';
import { Discover } from './components/Discover';
import { WhyStay } from './components/WhyStay';
import { LocationSection } from './components/LocationSection';
import { Reviews } from './components/Reviews';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { BookingBar } from './components/BookingBar';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  return <div className="w-full bg-ivory" data-id="element-0" data-mp="28t4kmbsl46ry">
      <Header data-id="element-1" data-mp="28s2zfehuu3wi" />
      <main data-id="element-2" data-mp="23vkw8j26adma">
        <Hero data-id="element-3" data-mp="23vuoyeelqyvo" />
        <PhotoCarousel data-id="element-4" data-mp="23u9ueosaffxt" />
        <Intro data-id="element-5" data-mp="23ut9lxqjzq85" />
        <Experience data-id="element-6" data-mp="23t8h0dnsuhcx" />
        <House data-id="element-7" data-mp="3ik7gwiph6frp" />
        <Reviews data-id="element-8" data-mp="3ikh5c1uvgeva" />
        <Breakfast data-id="element-9" data-mp="3iiwaeb4natww" />
        <Discover data-id="element-10" data-mp="3ijpbowku4r7n" />
        <WhyStay data-id="element-11" data-mp="3ii4su47vuwpm" />
        <LocationSection data-id="element-12" data-mp="3mlawr57iwbsx" />
        <Faq data-id="element-13" data-mp="3mkrgru1fnxhj" />
        <FinalCta data-id="element-14" data-mp="3mk85gw6ag7ch" />
      </main>
      <Footer data-id="element-15" data-mp="3mjgczu7zmpqf" />
      <BookingBar data-id="element-16" data-mp="3rc9dg5wfbbwp" />
      <WhatsAppButton data-id="element-17" data-mp="3rbrbqtqzs5he" />
    </div>;
}